import { render } from "./UpdateSubscriptionDialog.vue?vue&type=template&id=2b32da48&scoped=true"
import script from "./UpdateSubscriptionDialog.vue?vue&type=script&lang=js"
export * from "./UpdateSubscriptionDialog.vue?vue&type=script&lang=js"

import "./UpdateSubscriptionDialog.vue?vue&type=style&index=0&id=2b32da48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b32da48"]])

export default __exports__